import { PackageNamespace } from '@tablekit/package-namespace';
var itemThemeNamespace = PackageNamespace.Item;
var itemClassicTheme = {
  default: {
    background: 'transparent',
    textColor: function textColor(_ref) {
      var theme = _ref.theme;
      return theme.colors.text;
    },
    hoverBackground: function hoverBackground(_ref2) {
      var theme = _ref2.theme;
      return theme.colors.hoverNeutralBackground;
    },
    hoverTextColor: function hoverTextColor(_ref3) {
      var theme = _ref3.theme;
      return theme.colors.text;
    },
    beforeAfterColor: function beforeAfterColor(_ref4) {
      var theme = _ref4.theme;
      return theme.colors.iconFill;
    }
  },
  selected: {
    background: function background(_ref5) {
      var theme = _ref5.theme;
      return theme.colors.selectedBackground;
    },
    textColor: function textColor(_ref6) {
      var theme = _ref6.theme;
      return theme.colors.text;
    },
    borderColor: function borderColor(_ref7) {
      var theme = _ref7.theme;
      return theme.colors.primary;
    },
    beforeAfterColor: function beforeAfterColor(_ref8) {
      var theme = _ref8.theme;
      return theme.colors.iconFill;
    }
  },
  disabled: {
    textColor: function textColor(_ref9) {
      var theme = _ref9.theme;
      return theme.colors.textSubtle;
    },
    beforeAfterColor: function beforeAfterColor(_ref10) {
      var theme = _ref10.theme;
      return theme.colors.iconFill;
    }
  }
};
var itemDarkTheme = itemClassicTheme;
export { itemClassicTheme, itemDarkTheme, itemThemeNamespace };
